/**
 * SVContentRenewal: /video-renewal 전용 메인 비디오 영역.
 *
 * v1 원본: RenewalComponents/SVContent/ContentPresenter.js
 *          → screenMode 3모드 분기 + ShareFloating + Emoji
 *
 * ⚠ 이 컴포넌트는 .content.content--viewer 래퍼 내부에서 렌더링됨.
 *   래퍼는 VideoRenewalView.tsx에서 제공.
 */
import React from 'react';
import { useAppSelector } from '@/store/hooks';
import DivisionScreen from './DivisionScreen/DivisionScreen';
import SideScreen from './SideScreen/SideScreen';
import PresenterScreen from './PresenterScreen/PresenterScreen';
import Emoji from './Common/Emoji';
import TranslationFloating from '../TranslationFloating/TranslationFloating';
import { useShareFloatingNotification } from '@/hooks/useShareFloatingNotification';
import { useTranslationCreditNotice } from '@/hooks/useTranslationCreditNotice';
// import Emoji from './Common/Emoji'; // 개별 타일 내부로 이동

interface SVContentRenewalProps {
  localUserId: string;
  onSelectParticipant?: (userId: string | null) => void;
}

const SVContentRenewal: React.FC<SVContentRenewalProps> = ({ localUserId, onSelectParticipant }) => {
  const screenMode = useAppSelector((s) => s.ui.screenMode);

  // 다른 사용자의 화면/문서/스케치 공유 시 GlobalNotification으로 알림
  useShareFloatingNotification();
  // 크레딧 소진 시 전역 SNSnackbar로 알림
  useTranslationCreditNotice();

  return (
    <>
      {screenMode === 'GRID' && (
        <DivisionScreen localUserId={localUserId} onSelectParticipant={onSelectParticipant} />
      )}
      {screenMode === 'SIDE' && (
        <SideScreen localUserId={localUserId} onSelectParticipant={onSelectParticipant} />
      )}
      {screenMode === 'PRESENTER' && (
        <PresenterScreen localUserId={localUserId} onSelectParticipant={onSelectParticipant} />
      )}
      <Emoji />
      <TranslationFloating />
    </>
  );
};

export default SVContentRenewal;
